<div class="dialog">
  @if (showHeader()) {
    <header [class.with-border]="showHeaderBorder()">
      <h5>{{ title() }}</h5>
      <div class="dialog-close" (click)="dialogRef()?.close()"><i class="icon icon-close-X"></i></div>
    </header>
  }

  <section>
    <ng-content></ng-content>
  </section>

  <footer [class.with-border]="showFooterBorder()">
    <ng-content select="dialog-footer" />
  </footer>
</div>
